import React from 'react'

const ErrorView = () => <h1>Please contact #care-tech-support via Slack</h1>

export default ErrorView
